var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 54,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2937 17.0886C49.5487 17.0886 49.6761 17.0886 49.8036 17.3418L51.5882 20.1266C52.0981 21.0127 52.4805 21.8987 52.4805 22.9114V25.4431C52.4805 25.4431 54.9025 27.3418 54.9025 30.1266C54.9025 32.9114 53.2454 36.5823 51.0783 37.2152C50.9509 37.4684 50.8234 37.7215 50.8234 37.8481C50.5684 38.3544 50.0586 38.6076 49.5487 38.6076L49.1663 38.481V17.4684C49.0388 17.3418 49.0388 17.0886 49.2937 17.0886Z",
    fill: "#0089C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3868 47.4683C26.0044 47.4683 17.7187 47.2152 10.1978 44.1772C7.01098 42.9114 4.71648 40.1266 3.56923 36.2025C2.67692 33.2911 2.80439 30.7595 2.80439 30.6329H4.07912H3.44175H4.07912C4.07912 30.6329 3.95164 33.038 4.71648 35.8228C5.73626 39.3671 7.77582 41.7721 10.5802 42.9114C17.7187 45.8228 26.1319 46.0759 26.2593 46.0759L26.3868 47.4683Z",
    fill: "#0089C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1627 46.8354C34.1627 47.7215 33.3978 48.481 32.5055 48.481H27.5341C26.6418 48.481 25.877 47.7215 25.877 46.8354V46.5823C25.877 45.6962 26.6418 44.9367 27.5341 44.9367H32.5055C33.3978 44.9367 34.1627 45.6962 34.1627 46.5823V46.8354Z",
    fill: "url(#paint0_linear_350_27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5209 31.0127C7.5209 31.8987 6.75607 32.5316 5.99123 32.5316H3.44178C2.54947 32.5316 1.91211 31.7722 1.91211 31.0127V30.7595C1.91211 29.8734 2.67694 29.2405 3.44178 29.2405H5.99123C6.88354 29.2405 7.5209 30 7.5209 30.7595V31.0127Z",
    fill: "url(#paint1_linear_350_27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1979 17.2152C9.94296 17.2152 9.81549 17.2152 9.68801 17.4683L7.9034 20.2532C7.39351 21.1392 7.13856 22.0253 7.13856 23.038V25.5696C7.13856 25.5696 4.58911 27.4683 4.58911 30.2532C4.58911 33.038 6.24625 36.7088 8.41329 37.3418C8.54076 37.5949 8.66823 37.8481 8.66823 37.9747C8.92318 38.481 9.43307 38.7342 9.94296 38.7342L10.4528 38.6076V17.7215C10.4528 17.4683 10.3254 17.3418 10.1979 17.2152Z",
    fill: "#0089C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2043 22.2785C49.0768 20.3797 48.312 15.1899 45.2527 11.0127C45.3801 10.5063 45.2527 9.87341 44.8703 9.36708C36.4571 -5.72205e-06 23.3274 -5.72205e-06 15.0417 9.36708C14.6593 9.74683 14.5318 10.3797 14.5318 10.7595C10.7076 15.9494 10.4527 22.6582 10.3252 23.038V23.1645V38.8608C10.3252 40.1266 11.345 41.1392 12.6197 41.1392H12.7472C14.0219 41.1392 15.0417 40.1266 15.0417 38.8608V23.038C15.0417 21.7721 14.0219 20.7595 12.7472 20.7595C12.4922 20.7595 12.1098 20.7595 11.8549 20.8861C12.2373 18.6076 13.1296 14.6835 15.4241 11.519C15.8065 11.519 16.1889 11.3924 16.4439 11.0127C23.9648 2.53164 35.8197 2.53164 43.3406 11.0127C43.5955 11.2658 43.9779 11.519 44.2329 11.519C46.3999 14.557 47.2922 18.2278 47.6746 20.5063C47.4197 20.3797 47.1648 20.3797 46.9098 20.3797H46.7823C45.5076 20.3797 44.4878 21.3924 44.4878 22.6582V38.3544C44.4878 39.6202 45.5076 40.6329 46.7823 40.6329H46.9098C48.1845 40.6329 49.2043 39.6202 49.2043 38.3544V22.7848C49.3318 22.6582 49.3318 22.4051 49.2043 22.2785Z",
    fill: "url(#paint2_linear_350_27)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0896 24.481C18.6619 26.7468 19.363 29.7342 21.6448 31.1519C23.9265 32.5696 26.9349 31.8734 28.3626 29.6076C29.7903 27.3418 29.0892 24.3544 26.8074 22.9367C24.5257 21.519 21.5173 22.2152 20.0896 24.481ZM27.5085 28.7089C26.5907 30.5063 24.36 31.2279 22.5498 30.3038C20.7397 29.3798 20.0131 27.1772 20.9437 25.3798C21.8615 23.5823 24.0923 22.8608 25.9024 23.7848C27.7125 24.6962 28.4391 26.8987 27.5085 28.7089Z",
    fill: "url(#paint3_linear_350_27)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8821 17.1519C32.6201 19.0633 33.1683 21.6456 35.0931 22.8987C37.0179 24.1519 39.6184 23.6076 40.8804 21.6962C42.1423 19.7848 41.5942 17.2025 39.6694 15.9494C37.7445 14.6962 35.1441 15.2405 33.8821 17.1519ZM39.8861 19.443C39.8478 20.8608 38.6496 21.9747 37.2219 21.9114C35.8834 21.8481 34.7744 20.7089 34.7872 19.3671C34.7872 17.9494 35.9727 16.8101 37.4004 16.8481C38.8026 16.8861 39.9116 18.038 39.8861 19.443Z",
    fill: "url(#paint4_linear_350_27)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8355 23.6203C30.6825 23.3418 30.5296 23.0633 30.3384 22.8101L31.1414 21.4177C30.6953 20.8734 30.1727 20.3798 29.5863 19.9494L28.2223 20.7975C28.0184 20.6709 27.8144 20.557 27.6105 20.443C27.534 20.4051 27.4575 20.3671 27.3938 20.3418L27.381 18.7468C26.7054 18.4937 26.0043 18.3165 25.3032 18.2405L24.5511 19.6582C24.2324 19.6456 23.9138 19.6456 23.5951 19.6835L22.7793 18.3038C22.0782 18.4177 21.3771 18.6203 20.7142 18.8987L20.7779 20.4937C20.4975 20.6329 20.2171 20.7975 19.9621 20.9873L18.5599 20.1899C18.0118 20.6329 17.5146 21.1519 17.0812 21.7215L17.9353 23.076C17.8078 23.2785 17.6931 23.481 17.5784 23.6835C17.5401 23.7595 17.5019 23.8354 17.4764 23.8987L15.8702 23.9114C15.6153 24.5949 15.4368 25.2785 15.3604 25.9747L16.788 26.7215C16.7753 27.038 16.7753 27.3544 16.8135 27.6709L15.4241 28.481C15.5388 29.1899 15.7428 29.8734 16.0232 30.5316L17.6294 30.4684C17.7696 30.7468 17.9353 31.0253 18.1265 31.2785L17.3234 32.6709C17.7696 33.2152 18.2922 33.7089 18.8786 34.1392L20.2425 33.2911C20.4465 33.4177 20.6505 33.5316 20.8544 33.6456C20.9309 33.6835 21.0074 33.7215 21.0711 33.7468L21.0839 35.3544C21.7722 35.6076 22.4606 35.7848 23.1617 35.8608L23.9138 34.443C24.2324 34.4557 24.5511 34.4557 24.8698 34.4177L25.6856 35.7975C26.3995 35.6835 27.0878 35.481 27.7507 35.2025L27.6869 33.6076C27.9674 33.4684 28.2478 33.3038 28.5028 33.1139L29.905 33.9114C30.4531 33.4684 30.9502 32.9494 31.3836 32.3797L30.5296 31.0253C30.6571 30.8354 30.7718 30.6203 30.8865 30.4177C30.9247 30.3418 30.963 30.2658 30.9885 30.2025L32.6074 30.1899C32.8623 29.5063 33.0408 28.8228 33.1173 28.1266L31.6896 27.3797C31.7023 27.0633 31.6896 26.7468 31.6641 26.4304L33.0535 25.6203C32.9388 24.9114 32.7349 24.2279 32.4544 23.5696L30.8355 23.6203ZM28.6812 29.8101C27.1516 32.2532 23.901 33 21.4408 31.4684C18.9806 29.9494 18.2285 26.7215 19.7709 24.2785C21.3006 21.8354 24.5511 21.0886 27.0113 22.6203C29.4716 24.1392 30.2109 27.3671 28.6812 29.8101Z",
    fill: "url(#paint5_linear_350_27)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.505 14.1139C41.1226 13.8228 40.7019 13.5696 40.2558 13.3544L39.4272 14.1646C39.1468 14.0633 38.8408 13.9747 38.5476 13.9114L38.2927 12.7722C38.0505 12.7342 37.8083 12.7215 37.5533 12.7215C37.3112 12.7215 37.069 12.7215 36.814 12.7468L36.5081 13.8734C36.2021 13.9241 35.8962 13.9873 35.6158 14.0886L34.8254 13.2279C34.3665 13.4177 33.9331 13.6456 33.538 13.9241L33.8312 15.0506C33.589 15.2405 33.3723 15.4557 33.1683 15.6836L32.0465 15.3418C31.7533 15.7215 31.4984 16.1392 31.2817 16.5823L32.0975 17.4051C31.9828 17.6836 31.9063 17.9747 31.8426 18.2785L30.6953 18.5317C30.6571 18.7722 30.6443 19.0127 30.6316 19.2532C30.6316 19.4937 30.6316 19.7468 30.6571 19.9747L31.7916 20.2785C31.8426 20.5823 31.9063 20.8861 32.0083 21.1646L31.1542 21.9494C31.3454 22.4051 31.5749 22.8228 31.8553 23.2279L32.9898 22.9367C33.181 23.1772 33.3977 23.3924 33.6272 23.5949L33.283 24.7089C33.6654 25 34.0861 25.2532 34.5323 25.4684L35.3608 24.6456C35.6413 24.7595 35.9472 24.8355 36.2404 24.8987L36.4953 26.038C36.7375 26.076 36.9797 26.0886 37.2219 26.1013C37.4641 26.1013 37.7191 26.1013 37.9613 26.076L38.2672 24.9494C38.5731 24.8987 38.8791 24.8228 39.1595 24.7342L39.9498 25.5823C40.4087 25.3924 40.8421 25.1646 41.2373 24.8861L40.9441 23.7595C41.1863 23.5696 41.403 23.3544 41.607 23.1266L42.7287 23.4684C43.0219 23.0886 43.2769 22.6709 43.4936 22.2279L42.6777 21.4051C42.7925 21.1266 42.869 20.8228 42.9327 20.5317L44.0799 20.2785C44.1182 20.038 44.1309 19.7975 44.1437 19.557C44.1437 19.3165 44.1437 19.0633 44.1182 18.8228L42.9837 18.519C42.9327 18.2152 42.8562 17.9114 42.767 17.6329L43.621 16.8481C43.4298 16.3924 43.2004 15.962 42.9199 15.5696L41.7854 15.8608C41.5942 15.6203 41.3775 15.4051 41.1481 15.2025L41.505 14.1139ZM39.7714 15.7975C41.7854 17.1013 42.3463 19.7975 41.0333 21.7975C39.7204 23.7975 37.0052 24.3544 34.9912 23.0506C32.9771 21.7468 32.4162 19.0506 33.7292 17.0506C35.0549 15.0506 37.7573 14.4937 39.7714 15.7975Z",
    fill: "url(#paint6_linear_350_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_27",
    x1: 26.0062,
    y1: 46.6092,
    x2: 34.2114,
    y2: 46.8158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_350_27",
    x1: 1.69566,
    y1: 30.811,
    x2: 8.10607,
    y2: 30.9725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_350_27",
    x1: 30.035,
    y1: 29.0352,
    x2: 38.2692,
    y2: -14.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_350_27",
    x1: 19.3505,
    y1: 27.0428,
    x2: 29.1028,
    y2: 27.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_350_27",
    x1: 33.2064,
    y1: 19.4229,
    x2: 41.5651,
    y2: 19.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_350_27",
    x1: 15.3539,
    y1: 27.0425,
    x2: 33.1006,
    y2: 27.0425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_350_27",
    x1: 30.6366,
    y1: 19.4236,
    x2: 44.1371,
    y2: 19.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.9b693529ab8121589023f1337948c663.svg";
export { ForwardRef as ReactComponent };